module.exports = __webpack_public_path__ + "static/media/fe_insta.3c67c955.png";